<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="4" sm="8">
        <v-card class="mx-auto">
          <v-container>
            <v-card-title>
              <v-layout align-center justify-center>
                <v-img
                  class="tw-cursor-pointer"
                  contain
                  max-width="200"
                  src="@/assets/securating_logo.png"
                  @click="$router.push('/login')"
                />
              </v-layout>
              <div v-if="proAccount === 1" class="sr-securating-slogan">Entreprise</div>
            </v-card-title>

            <v-card-title v-if="step === 1 || step === 2">
              {{ $t("recover.title") }}
            </v-card-title>
            <v-card-title v-else-if="step === 3">
              {{ $t("pass.title") }}
            </v-card-title>

            <!-- Recover form -->
            <v-card-text>
              <Form v-if="step === 1" ref="recover" :callback="recover">
                <FormField v-model="email" i18n="recover.form.email" input-type="email" rules="required|email" />

                <div class="mt-2 mb-2">
                  <router-link to="/login">
                    {{ $t("login.return") }}
                  </router-link>
                </div>

                <Captcha @verify="captchaResolved = true"></Captcha>

                <v-btn
                  id="recover_submit"
                  :disabled="!captchaResolved"
                  :loading="loading"
                  block
                  class="mt-4 primary"
                  @click="$refs.recover.validate()"
                >
                  {{ $t("recover.submit") }}
                </v-btn>
              </Form>

              <div v-if="step === 2">
                <p v-html="$t('recover.emailing')"></p>
                <router-link to="/login">
                  {{ $t("login.submit") }}
                </router-link>
              </div>

              <Form v-if="step === 3" ref="pass" :callback="pass">
                <FormField
                  v-model="password"
                  :input-type="showPassword ? 'text' : 'password'"
                  i18n="pass.form.password"
                  place-holder=" "
                  rules="required"
                >
                  <template #append>
                    <v-icon v-if="showPassword" small @click="showPassword = false">fa-eye</v-icon>
                    <v-icon v-else small @click="showPassword = true">fa-eye-slash</v-icon>
                  </template>
                </FormField>

                <v-btn id="pass_submit" :loading="loading" class="mt-4 primary" small @click="$refs.pass.validate()">
                  {{ $t("pass.submit") }}
                </v-btn>
              </Form>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Types } from "@/store/modules/snackbar"
import { comeFromMe } from "@/helpers"
import Captcha from "@/components/common/Form/Captcha"

export default {
  name: "Recover",
  components: {
    Captcha,
  },
  data: () => ({
    step: 1,
    loading: false,
    email: "",
    showPassword: false,
    captchaResolved: false,
    password: "",
    proAccount: 0, //-- 0:me.account 1:manager.account
  }),
  mounted() {
    if (this.$route.query.hasOwnProperty("token")) {
      this.token = this.$route.query.token
      this.verifyToken().then(() => (this.step = 3))
    } else {
      if (this.$route.query.hasOwnProperty("email")) {
        this.email = this.$route.query.email
      }
    }
    if (comeFromMe()) {
      this.proAccount = 0
    } else {
      this.proAccount = 1
    }
  },
  methods: {
    verifyToken() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/user/recover/token", { token: this.token })
          .then(response => {
            resolve(response)
          })
          .catch(errors => {
            reject(errors.response.data)
          })
      })
    },
    pass() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch(Types.actions.HIDE)
        this.loading = true
        this.$axios
          .post("/user/recover/password", { password: this.password, token: this.token })
          .then(() => {
            this.loading = false
            this.cleanUrl()
            this.$router.push("/login")
            resolve()
          })
          .catch(errors => {
            this.loading = false
            reject(errors.response.data)
          })
      })
    },
    cleanUrl() {
      // Reset navigation
      delete this.$route.query.token
      delete this.$route.query.email
      history.replaceState(null, "", location.href.split("?")[0])
    },
    recover() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch(Types.actions.HIDE)
        this.loading = true
        this.$axios
          .post("/user/recover/email", { email: this.email, pro: this.proAccount })
          .then(() => {
            this.loading = false
            this.step = 2
            resolve()
          })
          .catch(errors => {
            this.loading = false
            reject(errors.response.data)
          })
      })
    },
  },
}
</script>
